{
  "version": 1,
  "asset_id": "ea2e05a6-a891-4c6a-8c0c-ba0b43e084bb",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/ea2e05a6-a891-4c6a-8c0c-ba0b43e084bb/svc-ecommerce-seo-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/ea2e05a6-a891-4c6a-8c0c-ba0b43e084bb/svc-ecommerce-seo-640.avif",
  "original_filename": "svc-ecommerce-seo-640.avif",
  "size": 13116,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:46Z"
}
